import styled from 'styled-components';
import { Button } from 'antd';
import { colors } from 'styles/colors';
import { fontSize } from 'styles/theme';
import { SlotState } from 'components/TutoringDateTimePicker/TutoringDateTimePicker.types';

export const STable = styled.table`
  table-layout: fixed;
  width: 100%;
`;

export const STd = styled.td<any>`
  width: 1%;
  text-align: center;
  white-space: pre;
  background: ${({ primetime }) => (primetime ? colors.blueLight : '')};
`;

export const STr = styled.tr<{ primetime?: boolean }>`
  background: ${({ primetime }) => (primetime ? colors.blueLight : '')};
  display: table;
`;

export const StyledThead = styled.thead`
  font-weight: bold;
`;

export const HeaderButtons = styled.div`
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
`;

export const CurrentWeekSpan = styled.span`
  display: grid;
  place-items: center;
  font-size: ${fontSize.xl};
  padding: 0 20px 0 20px;
`;

export const DaySpan = styled.span`
  display: block;
  font-size: ${fontSize['2xl']};
`;

export const StyledButton = styled(Button)`
  display: inline;
`;

export const TimeSlotBox = styled.div<{ slotState: SlotState }>`
  border-radius: 2px;
  background: ${(props) =>
    props.slotState === SlotState.AVAILABLE
      ? colors.primary
      : props.slotState === SlotState.BOOKED
      ? colors.blue
      : props.slotState === SlotState.UNAVAILABLE
      ? colors.darkGray
      : colors.gray12};
  color: ${(props) =>
    props.slotState === SlotState.AVAILABLE
      ? colors.white
      : props.slotState === SlotState.BOOKED
      ? colors.white
      : props.slotState === SlotState.UNAVAILABLE
      ? colors.white
      : colors.black};
  cursor: pointer;
  padding: 8px;
  margin: 3px 6px 3px 6px;

  &:hover {
    background: ${(props) =>
      props.slotState === SlotState.AVAILABLE
        ? colors.primary
        : props.slotState === SlotState.BOOKED
        ? colors.blue
        : colors.gray11};
  }
`;

export const StyledTbody = styled.tbody<any>`
  display: block;
  height: 380px;
  overflow-y: scroll;
  scrollbar-width: thin;
`;

export const VacancyReminderModalSpan = styled.span`
  display: block;
  margin: 20px 0;
`;
